import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { MatFieldComponent } from '../../../common/components';
import { ImageComponent } from '../../../common/components/image/image.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { ModalService } from '../../../common/services/modal.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { BaseComponent, BaseComponentOption } from '../../../common/components/base.component';
import { MatDialogRef, MatMenuTrigger } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { ConfigService } from '../../../services/config.service';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { config } from '../../../../config/config';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorDataCache,
  VisitorStyleStore,
} from '../../../stores/visitor.calendar.store';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../../hub/show.info.modal/show.info.modal.provider';
import { Analytics } from '../place.details.modal/place.details.modal.component';
import { EventDetailsModalActions } from './event.details.modal.provider';
import { SeoService } from '../../../services/seo.service';
import { VisitorSettingsCommand } from '../../../commands/pagination.query.command';
import { Subscription } from 'rxjs';
import { MediaQueryService } from '../../../services/media.query.service';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ToggleStore } from '../../../stores/hub.calendar.store';
import { isNullOrUndefined } from '../../../common/extensions';

@Component({
  templateUrl: './event.details.modal.component.html',
  styleUrls: ['./event.details.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EventDetailsModalComponent extends BaseComponent {
  public hubName: string;
  public event: HubEvent;
  public userID: string;
  public addressSegs: string[];
  public isLoadingAllEvents = false;
  public isLoadingEvent = true;
  public isTripPlannerOn = false;
  public mapZoom = 16;
  public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
  public customEvents: CustomEventCommand[];
  public customBtnContainsThisEvent = null;
  public USCenterLat = config.google.USCenter.lat;
  public USCenterLng = config.google.USCenter.lng;
  public analytics = new EventAnalytics();
  public settingsCommand = new VisitorSettingsCommand();
  public isNeedScroll = false;
  public stepPx = 30;
  public timeMousemoveInterval = null;
  public displayDescription = '';
  public toggles = new HubVisitorFeatureToggle();

  @ViewChild('mapColumn') public mapColumnEle: ElementRef;
  @ViewChild('descriptionEle') public descriptionEle: ElementRef;
  @ViewChild('imgComp') public imgComp: ImageComponent;
  @ViewChild('timewrap') public timeWrap: ElementRef;
  @ViewChild('eventTitle') public eventTitle: ElementRef;
  @ViewChild('description') public description: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<EventDetailsModalComponent>,
    private actions: EventDetailsModalActions,
    private visitorApiService: VisitorApiService,
    private modalService: ModalService,
    private location: Location,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    data: HubEvent
  ) {
    super();

    this.hubName = data.hubName;
    if (data && data._id && !data.startTime) {
      // eventId, from VisitorCalendarComponent
      this.loadEvents(data._id, data.hubName);
    } else {
      this.loadItem(data);
    }

    let settingStorage = localStorage.getItem(localStorageKeys.visitorSettings);
    if (!settingStorage) {
      settingStorage = localStorage.getItem(localStorageKeys.allFrontendSettingsForTP);
    }
    if (settingStorage) {
      const visitorSettings = JSON.parse(settingStorage) as VisitorSettingsCommand;
      this.settingsCommand = visitorSettings;
    }

    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.toggles = command.toggle;
        }
      });
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public get needReadMore() {
    if (this.event.socialName && this.event.socialName.includes('serp')) return false;

    return this.displayDescription && this.description && this.isEllipsisActive(this.description.nativeElement);
  }

  public get isMultiLinesTitle() {
    if (!this.eventTitle) return false;
    return this.eventTitle.nativeElement.getBoundingClientRect().height > 60;
  }

  public isEllipsisActive(e: HTMLElement) {
    if (!e) return false;
    return e.offsetHeight < e.scrollHeight;
  }

  public get normalTicketUri() {
    // return this.event && this.event.ticketUri && (!this.event.ticketInfo || !this.event.ticketInfo.length);

    return (
      this.event &&
      this.event.ticketUri &&
      (!this.event.ticketInfo ||
        !this.event.ticketInfo.length ||
        this.event.ticketUri !== this.event.ticketInfo[0].link)
    );
  }

  public get isSmallView() {
    // return !this.mediaQueryService.isPC;

    // all use small view design now
    return true;
  }

  public get processedTicketUri() {
    let noSchema = this.event.ticketUri.replace('https://', '');
    noSchema = noSchema.replace('http://', '');
    noSchema = noSchema.replace('www.', '');
    return noSchema.split('/')[0];
  }

  public get venueName() {
    if (!this.event) return '';
    return (
      this.event.venue ||
      (this.event.venueInfo && this.event.venueInfo.name) ||
      (this.event.owner && this.event.owner.name)
    );
  }

  public getLink(link) {
    if (link && !link.startsWith('http')) {
      return `http://${link}`;
    }
    return link;
  }

  public getString(obj) {
    return JSON.stringify(obj);
  }

  public openTicketUrl(link: string) {
    window.open(link.startsWith('http') ? link : `https://${link}`, '_blank');
  }

  public confirm(event: ButtonTriggerEvent) {
    this.actions.confirm(event);
    this.dialogRef.close();
  }

  public onUpcomingEventClick() {
    // close current
    this.dialogRef.close();
  }

  public get isLongDescriptionArea() {
    return this.event && this.event.eventTimes.length <= 2;
  }

  private loadEvents(eventId?, hubName?) {
    // let allEventsWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents));
    let allEventsWithCurrent = VisitorDataCache.events;
    let exist =
      allEventsWithCurrent && allEventsWithCurrent.length
        ? allEventsWithCurrent.first((x) => x._id === (eventId || this.event._id))
        : null;

    if (!this.event && !exist) {
      this.getEventById(hubName, eventId || this.event._id).subscribe((p) => {
        this.isLoadingEvent = false;
        if (p && p.length) {
          p[0].hubName = hubName;
          this.loadItem(p[0]);
          this.isLoadingAllEvents = true;
          this.getEvents(hubName).subscribe((data) => {
            this.isLoadingAllEvents = false;
            // localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data));
            VisitorDataCache.events = data;
          });
        } else {
          this.modalService.showErrorModal(
            'Uh-oh! Looks like this event has already happened! But don’t worry, we have more exciting events you can check on our calendar',
            'View All Upcoming Events'
          );
          this.close();
        }
        return;
      });
    } else {
      exist.hubName = hubName;
      this.loadItem(exist);
    }
  }

  public visitWebsite() {
    if (this.event.eventLink || this.event.hostLink) {
      let target = this.event.eventLink || this.event.hostLink;
      target = target.startsWith('http') ? target : `https://${target}`;
      window.open(target, '_blank');
    }

    this.addBuyTicketCount();
  }

  public getDirection() {
    let address = this.event.address.address || this.event.address;
    let url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
    window.open(url, '_blank');

    this.addGetDirectionCount();
  }

  /**
   * handle browser back button click, close the event details page
   * only close the details page is not enough, it will always have other loading issues for the script embedding solution
   * so force reload the page for now
   * */
  @HostListener('window:popstate', ['$event'])
  public hashChanged($event: Event) {
    $event.preventDefault();
    console.log('prevent default');
    let url = window.location.href.split('imgoing-event')[0];
    url = url.endsWith('?') ? url.substring(0, url.length - 1) : url;
    window.location.href = url;
    this.close();
  }

  private loadItem(event) {
    if (!event) {
      return;
    }
    this.event = event;
    this.imgComp && this.imgComp.updateImage(event.cover && event.cover.source);
    !this.event.isOnlineEvent && this.processAddress();
    this.processDescription();
    this.loadCustomBtns();

    if (!this.isScriptSolution) {
      SeoService.addNameIdToUrlForNonScriptSolution(this.location, event, this.dialogRef);
    } else {
      // for clients who use the whole html page solution (we give them a whole page that wraps ImGoing)
      // change the URL by adding the ImGoing event name + Id to the params so that each place has a unique URL
      // when close the details modal, reset the URL to the original URL of the host site
      if (SeoService.getIfNeedToAddNameIdToUrl()) {
        SeoService.addNameIdToUrlForScriptSolution(event, this.dialogRef);
      }
    }
    this.isLoadingEvent = false;

    setTimeout(() => {
      this.setEleStyle();
      SeoService.createAndInjectGoogleStructureDataScriptForEvent(this.event);
      this.getIsNeedScroll();
    }, 300);
  }

  public showEventLink() {
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData(
            'Event Link',
            null,
            [`${config.serverDomain}${this.event.hubName}/event-details/${this.event._id}`],
            null,
            true
          ),
        },
      ],
      panelClass: 'width-modal-4',
    });
  }

  public addBuyTicketCount() {
    this.analytics.gotoBuyTicketCount++;
  }

  public addGetDirectionCount() {
    this.analytics.getDirectionCount++;
  }

  public addShareEmail() {
    this.analytics.shareEmailCount++;
  }

  public addShareFB() {
    this.analytics.shareFBCount++;
  }

  public addShareTweet() {
    this.analytics.shareTweetCount++;
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    console.log('destroy', this.analytics);

    if (config.isAnalyticsOn) {
      this.visitorApiService.updateEventAnalytics(this.hubName, this.event._id, this.analytics).subscribe();
    }
  }

  public goLeft() {
    let x = 0;
    let interval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx * -1, 0);
      x = x + this.stepPx;
      if (x >= 192) {
        clearInterval(interval);
      }
    }, 5);
  }

  public goRight() {
    let x = 0;
    let interval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx, 0);
      x = x + this.stepPx;
      if (x >= 192) {
        clearInterval(interval);
      }
    }, 5);
  }

  public scrollLeft() {
    this.clearTimeMousemoveInterval();
    this.timeMousemoveInterval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx * -1, 0);
    }, 23);
  }

  public scrollRight() {
    this.clearTimeMousemoveInterval();
    this.timeMousemoveInterval = setInterval(() => {
      this.timeWrap.nativeElement.scrollBy(this.stepPx, 0);
    }, 23);
  }

  public clearTimeMousemoveInterval() {
    clearInterval(this.timeMousemoveInterval);
  }

  public get isAtStart() {
    if (!this.timeWrap) return true;
    const { scrollLeft } = this.timeWrap.nativeElement;
    return scrollLeft === 0;
  }

  public get isAtEnd() {
    if (!this.timeWrap) return false;
    const { scrollWidth, scrollLeft, clientWidth } = this.timeWrap.nativeElement;
    return scrollWidth - (scrollLeft + clientWidth) <= 10;
  }

  public scrollToStart() {
    if (this.timeWrap) {
      this.timeWrap.nativeElement.scroll(0, 0);
    }
  }

  @HostListener('window:resize')
  public getIsNeedScroll() {
    setTimeout(() => {
      if (this.timeWrap) {
        let scrollWidth = this.timeWrap.nativeElement.scrollWidth;
        let clientWidth = this.timeWrap.nativeElement.clientWidth;
        console.log(`scrollWidth: ${scrollWidth}, clientWidth: ${clientWidth}`);

        this.isNeedScroll = scrollWidth > clientWidth;
      }
    });
  }

  public showDescription() {
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData('Event Description', [], [this.event.description]),
        },
      ],
      panelClass: 'width-modal-4',
    });
  }

  private setEleStyle() {
    this.isLoadingAllEvents = false;
    this.mapColumnEle.nativeElement.style.height = '653px';
    this.descriptionEle.nativeElement.style.display = 'block';
    this.descriptionEle.nativeElement.style.height = '653px';
    this.description.nativeElement.scrollTop = 0;
  }

  private processAddress() {
    let addSegs = this.event.address.address.split(',');
    let last = addSegs[addSegs.length - 1];
    let cityArr = [],
      no = [];
    let take = parseInt(last, 10) ? 3 : 2;
    addSegs.forEach((x, index) => {
      if (index < addSegs.length - take) {
        if (x.length <= 3 && no.length > 0) {
          // if the address segment is less than 3 chars, it usually means the state name, connect it with the previous segment
          no[no.length - 1] = `${no[no.length - 1]}, ${x}`;
        } else {
          no.push(x);
        }
      } else {
        cityArr.push(x);
      }
    });
    this.addressSegs = [...no, cityArr.join(', ')];
  }

  private processDescription() {
    if (this.event.description && this.event.socialName && this.event.socialName.includes('serp')) {
      this.displayDescription = this.event.description;
      // if (!this.displayDescription.endsWith('read more</a>')) {
      if (this.displayDescription.endsWith('...')) {
        this.displayDescription += `&nbsp;<a href="${this.event.eventLink}" target="_blank">read more</a>`;
      }
      return;
    }

    if (this.event.description) {
      if (!this.displayDescription.endsWith('read more</a>')) {
        // remove html tags
        const regex = /(<([^>]+)>)/gi;
        this.displayDescription = this.event.description.replace(regex, '');
      }
    }
  }

  private loadCustomBtns() {
    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.customSettings) {
          this.customEvents = command.customSettings.customEvents || null;
          if (this.customEvents && this.customEvents.length) {
            this.customBtnContainsThisEvent = this.customEvents.filter((x) =>
              x.events.any((y) => y === this.event._id)
            );
          }
        }
        if (command.toggle) {
          this.isTripPlannerOn = command.toggle.tripPlanner;
        }
      });
  }

  private getEvents(hubName?): Observable<HubEvent[]> {
    return this.visitorApiService.getEvents(hubName || this.event.hubName, { page: 1, limit: 1000 });
  }

  private getEventById(hubName, id): Observable<HubEvent[]> {
    return this.visitorApiService.getEvents(hubName || this.event.hubName, {
      page: 1,
      limit: 1,
      id,
    });
  }
}

export class EventAnalytics extends Analytics {
  public gotoBuyTicketCount: number;

  constructor() {
    super();
    this.gotoBuyTicketCount = 0;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.details.modal/event.details.modal.component.ts